import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// GET /api/vendor — populates the per-row vendor picker on the shortage screen. size is
// generous (200) since this backs a <select>, not a paginated list.
//
// Moved from src/hooks/fetch-hooks/get-vendors/fetch-vendors.js onto the v2 hooks
// convention (throwIfRequestError) — see src/v2/hooks/request-error.js.
export default function useVendors() {
    return useQuery(
        ["pharmacy-vendors"],
        async () => {
            const result = await request({ url: "vendor", method: "GET", params: { page: 1, size: 200 } });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;
            return body.data?.rows || [];
        },
        { retry: false }
    );
}
